import {
  base64URLStringToBuffer,
  browserSupportsWebAuthn,
  bufferToBase64URLString,
  bufferToUTF8String,
  identifyAuthenticationError,
  toAuthenticatorAttachment,
  toPublicKeyCredentialDescriptor,
} from "./helpers";
import {
  AuthenticationResponseJSON,
  PublicKeyCredentialRequestOptionsJSON,
} from "./types";

export default async function startAuthentication(
  requestOptionsJSON: PublicKeyCredentialRequestOptionsJSON,
  useBrowserAutofill: boolean = false
): Promise<AuthenticationResponseJSON> {
  if (!browserSupportsWebAuthn()) {
    throw new Error("WebAuthn is not supported in this browser");
  }
  let allowCredentials;
  if (
    requestOptionsJSON.allowCredentials &&
    requestOptionsJSON.allowCredentials.length !== 0
  ) {
    allowCredentials = requestOptionsJSON.allowCredentials
      ? requestOptionsJSON.allowCredentials.map(toPublicKeyCredentialDescriptor)
      : undefined;
  }
  const publicKey = {
    ...requestOptionsJSON,
    challenge: base64URLStringToBuffer(requestOptionsJSON.challenge),
    allowCredentials,
  };
  const options = { publicKey };

  let credential: any;
  try {
    credential = (await navigator.credentials.get(
      options
    )) as AuthenticationResponseJSON;
  } catch (err: any) {
    // throw identifyAuthenticationError({ error: err, options });
    throw new Error("Very captivating error");
  }
  if (!credential) {
    throw new Error("Authentication was not completed");
  }
  const { id, rawId, response, type, clientExtensionResults } = credential;
  let userHandle = undefined;
  if (response.userHandle) {
    userHandle = bufferToUTF8String(response.userHandle);
  }

  return {
    id,
    rawId: bufferToBase64URLString(rawId),
    response: {
      authenticatorData: bufferToBase64URLString(response.authenticatorData),
      clientDataJSON: bufferToBase64URLString(response.clientDataJSON),
      signature: bufferToBase64URLString(response.signature),
      userHandle,
    },
    type,
    clientExtensionResults,
    authenticatorAttachment: credential.authenticatorAttachment,
  };
}
